<template>
  <div>
    <!-- 创建项目 -->
    <create-pro v-if="page === 3" />
    <!-- 修改项目名称 -->
    <edit-pro-name v-else-if="page===5" />
    <!-- 删除项目 -->
    <del-pro-item v-else-if="page===6" />
    <template v-else>
      <div
        v-if="isProjectListReady"
        class="project-list-container"
      >
        <header-back
          :title="baseinfo.comname"
          @back="resetHandler"
        >
          <router-link
            slot="right"
            class="project-head-r"
            :to="{name: 'AccountInfo'}"
          >
            <i class="icon iconfont iconicon-test44" />
          </router-link>
        </header-back>
        <!-- <template v-if="!$isDingDing && isTabShow">
          <cube-tab-bar
            v-model="type"
            show-slider
            class="cube-tab-bar-container"
          >
            <cube-tab
              v-for="item in tabs"
              :key="item.label"
              :label="item.name"
              :value="item.label"
            />
          </cube-tab-bar>
          <cube-tab-panels v-model="type">
            <cube-tab-panel
              v-for="item2 in tabs"
              :key="item2.label"
              :label="item2.name"
            >
              <div
                v-if="type === 'member'"
                class="member-tab-panel-tip"
              >
                会员管理项目暂未提供移动版本，请前往电脑端使用
              </div>
              <project-list
                :baseinfo="baseinfo"
                :datas="currentDatas"
                :is-btn="(type==='member' && datas.mc) || type === 'inquery'"
              />
            </cube-tab-panel>
          </cube-tab-panels>
        </template> -->
        <project-list
          :baseinfo="baseinfo"
          :datas="currentDatas"
        />
      </div>
      <div
        v-else
        class="loading"
      >
        <cube-loading :size="40" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import ProjectItem from './ProjectItem'
import HeaderBack from '@/components/mobile/HeaderBack'
import ProjectList from './ProjectList'
import EditProName from './EditProName'
import DelProItem from './DelProItem'
import CreatePro from './CreatePro'
import { clearPid } from '@/lib/storage'
export default {
  components: {
    ProjectList,
    HeaderBack,
    EditProName,
    DelProItem,
    CreatePro
  },
  data () {
    return {
      type: '',
      ishidden: 0,
      obj: {},
      baseinfo: {},
      isProjectListReady: false,
      /* tabs: [{
        label: 'inquery',
        name: '询盘管理'
      }, {
        label: 'member',
        name: '会员管理'
      }], */
      currentDatas: []
    }
  },
  computed: {
    ...mapState('organization/org', ['datasReady', 'datas']),
    ...mapState(['pid']),
    page () {
      return this.$route.query.page
    },
    cid () {
      return this.$route.query.cid
    },
    isTabShow () {
      const { mc = true, xp = true } = this.datas
      return mc && xp
    }
  },
  watch: {
    type (type) {
      this.currentDatas = this.datas.list['xp']
      /* this.triggerTab(type)
      this.setProjectType(type) */
    },
    datas: {
      handler (val) {
        this.currentDatas = val.list['xp']
      },
      deep: true
    }
    /* async $route () {
      const { cid = 0 } = this
      await this.fetchProjectList({ cid })
    } */
  },
  async mounted () {
    clearPid()
    this.setPid('')
    const { cid = 0 } = this
    const chain = await this.fetchProjectList({ cid })
    chain
      .onSuccess((data, res) => {
        // const defaultT = this.defaultType(data)
        // this.setProjectType()
        // this.$set(this.$route.query, 'type', defaultT)
        // this.type = defaultT
        // this.$router.push({ query: { type: defaultT, ...this.$route.query } })
        this.baseinfo = {
          isfounder: data.isfounder,
          isadmin: data.isadmin,
          comname: data.comname
        }
        this.currentDatas = data.list['xp']
        this.isProjectListReady = true
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchProjectList']),
    // ...mapMutations('organization/org', ['setProjectType']),
    ...mapMutations(['setPid']),
    resetHandler () {
      this.$router.push({
        name: 'OrgIndex',
        query: {
          page: 1
        }
      })
    }
    /* triggerTab (type) {
      this.setProjectType(type)
      this.$router.push({ name: 'ProjectIndexPc',
        query: {
          cid: this.cid,
          type
        }
      })
    } */
    /* defaultType (data) {
      let { type = '' } = this.$route.query
      let projectType = 'inquery'
      const { mc = true, xp = true } = data
      if (type === 'inquery' && xp) {
        projectType = 'inquery'
      } else if ((type === 'member' && mc) || (!xp && mc)) {
        projectType = 'member'
      } else {
        projectType = 'inquery'
      }
      return projectType
    } */
  }
}
</script>
<style lang="scss" scoped>
.cube-tab-bar-container::v-deep{
  height: 48px;
  line-height: 48px;
  background: #fff;
  margin-bottom: 12px;
  .cube-tab > div {
    font-size: 16px;
  }
  .cube-tab_active > div{
    font-weight: bold;
  }

}
 .project-head-r::v-deep {
    padding-right: 15px;
    i {
      color: #d6d6d6;;
    font-size: 24px;
    }
  }
  .member-tab-panel-tip {
    color: #fff;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #4ca0f2;
    opacity: 0.9;
    margin: -24px 0 10px;
  }
  .project-list-container::v-deep {
    padding-top: 20px;
    .cube-tab-panels {
      overflow: visible;
      padding: 12px 0;

    }
      .org-item {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 16px;
    margin:0 12px 12px;
    line-height: 24px;
    position: relative;
    display: flex;
    .iconicon-test25, .iconicon-test24 {
      font-size: 24px;
      color:#F6A953;
    }
    .iconicon-test7 {
      color: #42C27E;
      font-size: 24px;
    }
    .founder {
      color: #4CA0F2
    }
    .org-name {
      margin: 0 20px 0 10px;
      flex: 1;
      width: 290px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
    .iconicon-test27 {
      position: absolute;
      right: 16px;
      font-size: 20px;
      color: #ccc;
      top: 16px;
    }
  }
   .cube-form-tip-box {
    font-size: 14px;
    line-height: 24px;
    padding: 12px 0;
    h3 {
      font-weight: 600;
    }
    p{
      color: #999;
    }
  }
  .create-box button.cube-btn-light {
     border-top: 1px solid #ebebeb;
    background: #fff;
  }
  }
</style>
